// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@sc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { rfqQuoteDetailsMessagesStyles } from "@sc/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsMessages";
import { hideElementOnPrint, mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsMessagesStyles.mainWrapper = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.wrapper, {
        css: css`
            flex-direction: column;
        `,
    }),
};

rfqQuoteDetailsMessagesStyles.messageTextArea = {
    css: css`
        min-width: 100%;
        max-width: 100%;
        min-height: 50px;
        resize: vertical;
    `,
    cssOverrides: {
        formField: css`
            margin-bottom: 20px;
            ${hideElementOnPrint}
        `,
    },
};

rfqQuoteDetailsMessagesStyles.sendButton = {
    css: css`
        ${hideElementOnPrint}
    `,
};

rfqQuoteDetailsMessagesStyles.mainWrapperNoMessages = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.wrapper, {
        css: css`
            flex-direction: column;
            ${hideElementOnPrint}
        `,
    }),
};

rfqQuoteDetailsMessagesStyles.userNameText = {
    weight: "bold",
    css: css`
        @media print {
            margin-right: 10px;
        }
    `,
};
